import React, { FC } from "react";
import { Button, createStyles, Dialog, DialogActions, DialogTitle, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fullWidth: {
        width: '100%',
    }
  }),
);

interface FormDialogProps {
  open: boolean;
  title: string;
  onCloseCancel: () => void;
  onCloseSubmit: () => void;
  // content: React.FC<{}>;//JSX.Element;
}

const FormDialog: FC<FormDialogProps> = ({ onCloseCancel, onCloseSubmit, children, open, title }) => {
    const classes = useStyles();

  return (
    <Dialog
        open={open}
        //onClose={handleClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        className={classes.fullWidth}
      >
        <DialogTitle id="dialog-title">{title}</DialogTitle>
        {children}
        <DialogActions>
            <Button onClick={onCloseCancel} color="primary">
            Annuller
          </Button>
          <Button onClick={onCloseSubmit} color="primary">
            Fuldfør
          </Button>
        </DialogActions>
      </Dialog>
  );
}

export default FormDialog;